export function nextClassPrefix(c) {
	if (c[c.length - 1] === 'z') {
		return `${ c.substr(0, c.length - 1) }aa`;
	}
	const next = `${ c.substr(0, c.length - 1) }${ String.fromCharCode(c.charCodeAt(c.length - 1) + 1) }`;
	return next;
}
